import { createCrudApi } from '@core/api/createCrudApi';
import type { User } from '@core/api/user';
import type { BaseEntity } from '@core/interfaces';
import axiosInstance from '@core/utils/axiosInstance';

export interface Tenant extends BaseEntity {
  name: string;
  description?: string | null;
  address?: string | null;
  email?: string | null;
  phone?: string | null;
}

export interface CreateTenantData {
  name: string;
  description?: string;
  address?: string;
  email?: string;
  phone?: string;
}

export type UpdateTenantData = Partial<CreateTenantData>;

const tenantApi = createCrudApi<Tenant, CreateTenantData, UpdateTenantData>(
  'tenant'
);

export const getAllTenants = tenantApi.getAll;
export const getTenantById = tenantApi.getById;
export const createTenant = tenantApi.create;
export const updateTenant = tenantApi.update;
export const deleteTenant = tenantApi.delete;

export async function resetTenant(tenantId: number): Promise<void> {
  await axiosInstance.post(`/tenant/${tenantId}/reset`);
}

export async function getTenantUsers(tenantId: number): Promise<User[]> {
  const { data } = await axiosInstance.get<User[]>(`/tenant/${tenantId}/users`);
  return data;
}

export async function getMyTenant(): Promise<Tenant> {
  const { data } = await axiosInstance.get<Tenant>('/tenant/me');
  return data;
}

export async function updateMyTenant(
  payload: UpdateTenantData
): Promise<Tenant> {
  const { data } = await axiosInstance.put<Tenant>('/tenant/me', payload);
  return data;
}
